import React from "react";

import "../cards/cards.css";
import { Card, Stack } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const PopularCard = ({ val }) => {
  return (
    <>
      <Card className="rounded-2 shadow-sm popular">
        <Card.Img
          variant="top"
          src={val.image}
          className="img-fluid"
          alt={"image"}
        />
        <Card.Body>
          <Card.Text>
            <i className="bi bi-geo-alt"></i>
            <span className="text">{val.location}</span>
          </Card.Text>

          <Card.Title>
            <NavLink
              className="body-text text-dark text-decoration-none"
              to="/tour-details"
            >
              {val.title}
            </NavLink>
          </Card.Title>

          {val.category.map((cat, index) => {
            return (
              <span key={index} className={cat.replace(/ .*/, "") + " badge"}>
                {cat}
              </span>
            );
          })}
        </Card.Body>

        <Card.Footer className="py-4">
          <p>
            <i className="bi bi-calendar3"></i>&emsp;{val.date}
          </p>
        </Card.Footer>
      </Card>
    </>
  );
};

export default PopularCard;
